import { render, staticRenderFns } from "./userSportTerms.vue?vue&type=template&id=04647961&scoped=true"
import script from "./userSportTerms.vue?vue&type=script&lang=js"
export * from "./userSportTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04647961",
  null
  
)

export default component.exports